import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class ExternalConnectionService {
    apiUrl:string
    constructor(private http: HttpClient,
        private config:AppConfig) { 
            this.apiUrl=this.config.getConfig('apiUrl')
        }

    getAllExternalConnections() {
        return this.http.get(this.apiUrl+`/ext-conn/getAll`).pipe();
    }

    createExternalConnection(payload) {
        return this.http.post(this.apiUrl+`/ext-conn/create`, payload).pipe();
    }

    updateExternalConnection(payload) {
        return this.http.post(this.apiUrl+`/ext-conn/create`, payload).pipe();
    }

    deleteExternalConnection(id) {
        return this.http.put(this.apiUrl+`/ext-conn/delete?id=` + id, "").pipe();
    }
}